export default __webpack_public_path__ + "assets/certificates/Test report.e9c9c733.pdf";